import styled from 'styled-components'

const SuperAdministratorManualStyled = styled.div`
  .title-container {
    padding: 30px 60px;
  }

  .iframe-container {
    width: 87vw;
    height: 94%;
    border: none;
    overflow: hidden;
    margin: 0 auto;
    padding: 0;
    position: fixed;  

  @media (max-width: 1440px) {
    width: 80vw;
    height: 88%;
  }

  @media (max-width: 1024px) {
    width: 76vw;
  }
 
  @media (max-width: 475px) {
    width: 60vw;
    height: 90%;
  }
}
`
export default SuperAdministratorManualStyled
